import { ReactElement } from 'react';

import { Box, Stack } from '@mui/material';
import { styled } from '@mui/system';
import { Outlet } from 'react-router-dom';

import { APP_LAYOUT_HEIGHT } from '@/config';
import { AppHeader } from '../app';

// import { AppHeader, AppSidebar } from '../app';

const Content = styled(Box)({
  display: 'flex',
  padding: '30px 20px',
  flexDirection: 'column',
  flexGrow: 1,
  backgroundColor: 'white',
  flexBasis: `calc(100vh - ${APP_LAYOUT_HEIGHT.HEADER + APP_LAYOUT_HEIGHT.CONTENT_HEADER}px)`,
  overflow: 'auto',
});

export const MainLayout = (): ReactElement => {
  return (
    <Stack width="100vw">
      <AppHeader />

      <Content>
        <Outlet />
      </Content>
    </Stack>
  );
};
